import styled from 'styled-components';
import { repeat } from 'lodash';

export default styled.div`
  margin-top: 2rem;
  display: grid;
  grid-template-columns: ${({ cols }) => repeat(' 1fr', cols || 1)};
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
`;
